import React from 'react';
import { Modal, message } from 'antd';
import { connect } from 'dva';
import _cloneDeep from 'lodash/cloneDeep';
import StructureTree from './StructureTree/Index.js';
import SelectedPart from './SelectedPart/Index.js';
import ShowTable from './ShowTable/Index.js';
import styles from './Index.less';

@connect(({ AddressBook }) => ({
  chargeTarget: AddressBook.chargeTarget,
}))
export default class Address extends React.Component {
  constructor(props) {
    super(props);

    // 每次选择人员重复的表格项集合
    this.recurredList = [];

    this.state = {
      confirmLoading: false,
      renderContent: props.renderContent,
      tableList: _cloneDeep(props.tableList || []),
    };

    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleAddUser = this.handleAddUser.bind(this);
    this.handleDelUser = this.handleDelUser.bind(this);
    this.getNewTableList = this.getNewTableList.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { chargeTarget: { visible, tableList } } = nextProps;

    // 重置数据
    if (visible === false) {
      this.setState({ tableList: [] });

      this.props.dispatch({
        type: 'AddressBook/saveOrgId',
        orgId: null,
      });
    } else {
      this.setState({ tableList: _cloneDeep(tableList || []) });
    }
  }

  // 获取新的人员集合（表格展示）
  getNewTableList() {
    const { tableList } = this.state;
    const { selected, addressBook, exceptNodes, schoolName } = this.props.chargeTarget;
    const resultList = [];

    return this.props
      .dispatch({
        type: 'AddressBook/fetchTableList',
        selectedList: selected,
        treeData: addressBook,
        schoolName,
        exceptNodes,
      })
      .then(newTableList => {
        // 如果显示的是树组件，不需要进行数据去重
        if (this.props.renderContent === 'tree') {
          return _cloneDeep(newTableList);
        }

        // 初始化重复表格项集合
        this.recurredList = [];

        tableList.forEach(item => {
          const result = newTableList.some(newItem => item.id === newItem.id);

          if (result) {
            this.recurredList.push(item);
          } else {
            resultList.push(item);
          }
        });

        return _cloneDeep(newTableList.concat(resultList));
      });
  }

  handleOk() {
    const { renderContent, onOk, dispatch } = this.props;

    // 当前处于表格展示，确定按钮相当于拿到人员数据，关闭组件
    if (renderContent === 'table' && this.state.renderContent === 'table') {
      // 将当前的表格数据抛出去
      if (onOk) {
        onOk({
          userList: this.state.tableList,
          recurredList: this.recurredList,
        });
      }

      // 隐藏模态框
      return dispatch({
        type: 'AddressBook/setChargeTarget',
        payload: {
          visible: false,
        },
      });
    }

    this.setState({
      confirmLoading: true,
    });

    this.getNewTableList().then(newTableList => {
      this.setState({
        confirmLoading: false,
      });

      // 如果显示table，并且此时正在结构树，点击确定相当于完成人员选择
      if (renderContent === 'table' && this.state.renderContent === 'tree') {
        return this.setState({
          tableList: _cloneDeep(newTableList),
          renderContent: 'table',
        });
      }

      if (newTableList.length === 0) {
        message.warning('请选择人员');
        return;
      }

      // 将选择的人员数据抛出去
      if (onOk) {
        onOk({
          userList: newTableList,
          recurredList: this.recurredList,
        });
      }

      // 隐藏模态框
      dispatch({
        type: 'AddressBook/setChargeTarget',
        payload: {
          visible: false,
        },
      });
    });
  }

  handleCancel() {
    this.props.dispatch({
      type: 'AddressBook/setChargeTarget',
      payload: {
        visible: false,
      },
    });
  }

  // 新增人员，跳转到结构树组件
  handleAddUser() {
    this.setState({
      renderContent: 'tree',
    });
  }

  // 删除表格项
  handleDelUser(user) {
    const tableList = _cloneDeep(this.state.tableList);

    tableList.some((item, index, arr) => {
      if (item.id === user.id) {
        arr.splice(index, 1);
      }
      return item.id === user.id;
    });

    // 对应的重复人员集合也需要遍历
    this.recurredList.some((item, index, arr) => {
      if (item.id === user.id) {
        arr.splice(index, 1);
      }
      return item.id === user.id;
    });

    this.setState({ tableList });
  }

  renderContent() {
    const { renderContent, tableList } = this.state;
    const { entitySigns } = this.props;

    if (renderContent === 'tree') {
      return (
        <div>
          {/* 已选择的人员集合 */}
          <SelectedPart />
          {/* 机构树 */}
          <StructureTree entitySigns={entitySigns} />
        </div>
      );
    } else if (renderContent === 'table') {
      return (
        <ShowTable
          sourceData={tableList}
          onAddUser={this.handleAddUser}
          onDelUser={this.handleDelUser}
        />
      );
    }
  }

  render() {
    const { visible } = this.props.chargeTarget;
    if (visible !== true) {
      return null;
    }

    const { confirmLoading, renderContent, tableList } = this.state;

    let okButtonDisabled = false;

    if (renderContent === 'table' && tableList.length === 0) {
      okButtonDisabled = true;
    }

    const okButtonProps = {
      disabled: okButtonDisabled,
    };

    if (visible !== true) {
      return null;
    }

    return (
      <Modal
        title="选择人员"
        destroyOnClose
        className={styles.root}
        confirmLoading={confirmLoading}
        visible
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        okButtonProps={okButtonProps}
        width={900}
      >
        {this.renderContent()}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/Address/Index.js